module.exports = __webpack_public_path__ + "img/Voucher Icon - white.230cd05d.svg";